import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import LiveMatchStat from "@/modules/match/components/LiveMatchStat.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchStats',
  props: {
    match: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(LiveMatchStat, {
        label: _ctx.$t('goals'),
        "home-value": __props.match.homeGoals,
        "away-value": __props.match.awayGoals
      }, null, 8, ["label", "home-value", "away-value"]), _createVNode(LiveMatchStat, {
        label: _ctx.$t('chances'),
        "home-value": __props.match.homeChances ?? 0,
        "away-value": __props.match.awayChances ?? 0
      }, null, 8, ["label", "home-value", "away-value"]), _createVNode(LiveMatchStat, {
        label: _ctx.$t('possession'),
        "home-value": __props.match.homePossession ?? 0,
        "away-value": __props.match.awayPossession ?? 0,
        percentage: ""
      }, null, 8, ["label", "home-value", "away-value"])], 64);
    };
  }
});